module.exports = "https://www.gc-pro.gnp.com.mx/7b3aaecd6f0b341ff42c597da2a3f7f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-invitacion.png
// module id = 8125
// module chunks = 0